import React, { useState } from 'react';
import { cloneDeep } from 'lodash';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { showToast } from 'stores/ToastStore';
import { ConfirmActionModal } from 'components/ui/modal';
import ListItem from 'components/v2/list/ListItem';
import Dropdown from 'components/v2/dropdowns/DropdownV2';
import { useCreateWarehouseWithAssociations, useDeleteWarehouseWithAsssociation, } from 'hooks/warehouse/useManageWarehouse';
import WarehouseSummary from './WarehouseSummary';
import WarehouseForm from './WarehouseForm';
const WarehouseListItem = ({ data, actionsEnabled, defaultOpen }) => {
    const { t } = useTranslation();
    const [showDeleteLocationModal, setShowDeleteLocationModal] = useState(false);
    const [updating, setUpdating] = useState(false);
    const onDeleteWarehouseSuccess = () => {
        showToast(t('DELETE_WAREHOUSE_SUCCESS'), t('DELETE_WAREHOUSE_SUCCESS'), 'success');
        setShowDeleteLocationModal(false);
    };
    const onDeleteWarehouseFail = () => {
        showToast(t('DELETE_WAREHOUSE_FAILED'), t('DELETE_WAREHOUSE_FAILED'), 'error');
    };
    const { mutation: deleteLocationMutation } = useDeleteWarehouseWithAsssociation(onDeleteWarehouseSuccess, onDeleteWarehouseFail);
    const onUpdateSuccess = (response) => {
        var _a, _b;
        if ((_a = response === null || response === void 0 ? void 0 : response.unprocessed_items) === null || _a === void 0 ? void 0 : _a.length) {
            let errorMessage = '';
            if (((_b = response === null || response === void 0 ? void 0 : response.unprocessed_items) === null || _b === void 0 ? void 0 : _b.length) === 1) {
                errorMessage += response.unprocessed_items[0].message;
            }
            else {
                errorMessage = response.unprocessed_items.reduce((acc, e, idx) => {
                    acc += `${idx + 1}. ${e.message} \n`;
                    return acc;
                }, '');
            }
            showToast('', errorMessage, 'error');
        }
        else {
            showToast(t('UPDATE_WAREHOUSE_SUCCESS'), t('UPDATE_WAREHOUSE_SUCCESS'), 'success');
        }
    };
    const onUpdateFailed = (err) => {
        if (err === null || err === void 0 ? void 0 : err.message) {
            showToast('', err.message, 'error');
        }
        else {
            showToast(t('UPDATE_WAREHOUSE_FAILED'), t('UPDATE_WAREHOUSE_FAILED'), 'error');
        }
        setUpdating(false);
    };
    const { mutation: updateMutation } = useCreateWarehouseWithAssociations(onUpdateSuccess, onUpdateFailed);
    function handleShowEditMode(showFormView) {
        return function () {
            showFormView();
        };
    }
    const handleDelete = () => {
        if ((data === null || data === void 0 ? void 0 : data._id) && (data === null || data === void 0 ? void 0 : data.isFromApi)) {
            setShowDeleteLocationModal(true);
        }
    };
    const renderActions = (showFormView) => {
        return (React.createElement(React.Fragment, null,
            React.createElement(Dropdown.Button, { onClick: handleShowEditMode(showFormView) }, t('EDIT')),
            React.createElement(Dropdown.Button, { onClick: handleDelete },
                " ",
                t('DELETE'))));
    };
    const handleEditWarehouseAssociations = async (payload) => {
        setUpdating(true);
        await updateMutation.mutateAsync(payload);
        setUpdating(false);
    };
    const onValidSuccess = async (data, onSaveSuccess, onSaveFail, hideFormView) => {
        if (data) {
            try {
                await handleEditWarehouseAssociations(data);
                onSaveSuccess();
                hideFormView();
            }
            catch (e) {
                onSaveFail();
            }
        }
    };
    const onValidFail = (onSaveFail) => {
        onSaveFail();
    };
    const renderForm = (saving, onSaveSuccess, onSaveFail, hideFormView) => {
        return (React.createElement(WarehouseForm, { data: cloneDeep(data), saving: saving, onSaveFail: onSaveFail, onValidFail: () => onValidFail(onSaveSuccess), onValidSuccess: (data) => onValidSuccess(data, onSaveSuccess, onSaveFail, hideFormView), afterSave: hideFormView }));
    };
    const handleDeleteLocationApi = async (id) => {
        setUpdating(true);
        await deleteLocationMutation.mutateAsync(id);
        setUpdating(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ListItem, { actionsEnabled: actionsEnabled, actions: renderActions, form: renderForm, defaultOpen: true, testDataId: "warehouse-list-item" }, () => (React.createElement(WarehouseSummary, { data: cloneDeep(data), defaultOpen: defaultOpen }))),
        showDeleteLocationModal && (React.createElement(ConfirmActionModal, { title: t('DELETE_WAREHOUSE_TITLE'), isOpen: showDeleteLocationModal, onClose: () => {
                setShowDeleteLocationModal(false);
                setUpdating(false);
            }, onConfirm: () => handleDeleteLocationApi(data === null || data === void 0 ? void 0 : data._id), confirmActionColor: "red", confirmActionText: t('DELETE'), actionDisabled: updating }, t('DELETE_WAREHOUSE_MSG')))));
};
WarehouseListItem.propTypes = {
    actionsEnabled: PropTypes.bool,
    defaultOpen: PropTypes.bool,
};
WarehouseListItem.defaultProps = {
    actionsEnabled: true,
    defaultOpen: false,
};
export default WarehouseListItem;
